// assets/geo-city.js
(async () => {
  const el = document.getElementById('ga-geo-place');
  if (!el || !('geolocation' in navigator)) return;

  const setCity = (text) => text && (el.textContent = text);

  try {
    // Respect permission (don’t prompt if denied)
    if (navigator.permissions) {
      const status = await navigator.permissions.query({ name: 'geolocation' });
      if (status.state === 'denied') return;
    }

    // Ask for location
    const pos = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        timeout: 4000
      });
    });

    // Reverse geocode via OpenStreetMap
    const { latitude, longitude } = pos.coords;
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&zoom=10`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return;
    const data = await res.json();

    const addr = data.address || {};
    const city = addr.city || addr.town || addr.village || addr.county || addr.state;
    setCity(city);
  } catch {
    // keep default text
  }
})();
